import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {path: "/", name: "home", component: () => import('./views/Home.vue')},
    {path: "/login", name: "login", component: () => import('./views/Login.vue')},
    {path: "/forgot-password", name: "forgot-password", component: () => import('./views/ForgotPassword.vue')},

    {path: "/tasks", name: "tasks", component: () => import('./views/task/Tasks.vue')},
    {path: "/task-form", name: "task-form", component: () => import('./views/task/TaskForm.vue')},
    {path: "/task-detail/:taskId", name: "task-detail", component: () => import('./views/task/TaskDetail.vue')},
    {path: "/delivery", name: "delivery", component: () => import('./views/task/Delivery.vue')},
    {path: "/balance-sheets", name: "balance-sheets", component: () => import('./views/balance-sheet/BalanceSheets.vue')},
    {path: "/balance-sheet-detail/:balanceSheetId", name: "balance-sheet-detail", component: () => import('./views/balance-sheet/BalanceSheetDetail.vue')},
    {path: "/cashflows", name: "cashflows", component: () => import('./views/cashflow/Cashflows.vue')},
    {path: "/cashflow-detail/:cashflowId", name: "cashflow-detail", component: () => import('./views/cashflow/CashflowDetail.vue')},
    {path: "/profits", name: "profits", component: () => import('./views/profit/Profits.vue')},
    {path: "/profit-detail/:profitId", name: "profit-detail", component: () => import('./views/profit/ProfitDetail.vue')},
    {path: "/contracts", name: "contracts", component: () => import('./views/contract/Contracts.vue')},
    {path: "/contract-detail/:contractId", name: "contract-detail", component: () => import('./views/contract/ContractDetail.vue')},
    {path: "/receipt-counts", name: "receiptCounts", component: () => import('./views/receipt-count/ReceiptCounts.vue')},
    {path: "/company-info", name: "companyInfo", component: () => import('./views/company/CompanyInfoForm.vue')},
    {path: "/tax-filings", name: "tax-filings", component: () => import('./views/tax-filing/TaxFilings.vue')},
    {path: "/tax-filing-detail/:taxFilingId", name: "tax-filing-detail", component: () => import('./views/tax-filing/TaxFilingDetail.vue')},
    {path: "/balances", name: "balances", component: () => import('./views/balances/Balances.vue')},
    {path: "/preview/:id", name: "preview", component: () => import('./views/preview/Preview.vue')}
  ]
});

router.beforeEach((to, from, next) => {
  // 记住登录前的路由
  if (to.name !== 'login' && to.name !== 'forgot-password') {
    localStorage.setItem('fromPath', to.name);
  }

  let auth = localStorage.getItem('accessToken');
  if (!auth) {
    if (to.name !== 'login' && to.name !== 'forgot-password') {
      !!auth ? next() : next('/login');
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;

// function currentUser() {
//   let accessToken = localStorage.getItem("accessToken");
//   if (accessToken == null) {
//     return null;
//   } else {
//     let decoded = jwt_decode(accessToken);
//     return {username: decoded.sub, role: decoded.role, firmId: decoded.firm, companyId: decoded.company};
//   }
// }
